
import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: 'https://api.fruitsweb3.xyz/api', 
});


axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);
axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        localStorage.removeItem('token'); 
      }
      return Promise.reject(error);
    }
  );
export default axiosInstance;
